export const paymentsSelector = ({ rocketPay: { payments: value } }) => value;

export const emailFiltersSelector = ({ rocketPay: { emailFilters: value = { data: [] } } }) => value;
export const statusFiltersSelector = ({ rocketPay: { statusFilters: value = { data: [] } } }) => value;

export const webComponentTokenSelector = ({ rocketPay: { webComponentToken: value = '' } }) => value;
